<template>
  <div id="silent-renew">
  </div>
</template>

<script>
  import Oidc from 'oidc-client'

  export default {
    name: 'silent-renew',
    methods: {
    },
    mounted() {
      new Oidc.UserManager().signinSilentCallback();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/auth/silent-renew.vue